import type { RegistrationStatus, RegistrationStatusRequest } from "./types"

import { getApiUrl } from "@/modules/api/api"
import { keysToCamelCase } from "@/modules/apiRequests/dataStructure"
import { getResultFromResponse } from "@/modules/apiRequests/handlers"
import { REGISTRATION_STATUS_ENDPOINT } from "@/modules/eventDetails/client/constants/api"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"
import { DEFAULT_LOCALE } from "@/modules/locales/constants"

export const getRegistrationStatus = async (params: RegistrationStatusRequest): Promise<RegistrationStatus> => {
  const { eventId, locale } = params

  return fetcher(
    getApiUrl({ path: REGISTRATION_STATUS_ENDPOINT }),
    {
      body: JSON.stringify({ event_id: eventId }),
      headers: {
        "Accept-Language": locale || DEFAULT_LOCALE,
      },
      method: "POST",
    },
    { serviceDomain: "GATEWAY_API" }
  )
    .then(getResultFromResponse<RegistrationStatus>({ transformResult: keysToCamelCase<RegistrationStatus> }))
    .catch(handleFetchError(REGISTRATION_STATUS_ENDPOINT, params))
}
